import {Component, inject, Input} from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { HasRolesDirective } from 'keycloak-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ListeCompromiseReportsComponent } from 'src/app/compromise-reports/liste-compromise-reports/liste-compromise-reports.component';
import { TranslationService } from 'src/app/service/translation.service';
import { environment } from 'src/environments/environment';
import { StatisticsComponent } from '../statistics/statistics.component';
import { ListBrowserAttestationsComponent } from 'src/app/attestations/list-browser-attestations/list-browser-attestations.component';
import { ListeAttestationsComponent } from 'src/app/attestations/liste-attestations/liste-attestations.component';
import { SettingsComponent } from 'src/app/settings/settings.component';
import { RefPoliciesComponent } from 'src/app/settings/ref-policies/ref-policies.component';
import { ClientsSettingsComponent } from 'src/app/settings/clients-settings/clients-settings.component';
import { SimulationComponent } from 'src/app/security-policies/simulation/simulation.component';
import { ActivePoliciesComponent } from 'src/app/security-policies/active-policies/active-policies.component';
import Keycloak from 'keycloak-js';
import { ToastComponent } from '../toast/toast.component';
/**
 * Child Component useful for all "main" components (see routes in app.routes.ts) which allow
 * 
 * according to attributes 'type' to let them have a tab. It's more comfortable
 * 
 * for the user to have this instead of multiple routes.
 */
@Component({
    selector: 'app-navtabs',
    templateUrl: './navtabs.component.html',
    styleUrls: ['./navtabs.component.scss'],
    providers: [TranslationService],
    imports: [
      HasRolesDirective, 
      TranslateModule, 
      NgbNavModule,
      ListeCompromiseReportsComponent,
      ListBrowserAttestationsComponent,
      ListeAttestationsComponent,
      StatisticsComponent,
      SettingsComponent,
      RefPoliciesComponent,
      ClientsSettingsComponent,
      SimulationComponent,
      ActivePoliciesComponent,
      ToastComponent
    ],
    standalone: true
})
export class NavtabsComponent {

  @Input() type?: string;
  private readonly translationService = inject(TranslationService);
  private readonly keycloak = inject(Keycloak);
  public env = environment;

  getSecurityTabs() {
    return [
      {
        id: 'active',
        img: 'assets/icons/list.svg',
        imgId: 'list',
        label: 'security-policies-nav-active-list',
        content: 'active'
      },
      {
        id: 'simulation',
        img: 'assets/icons/ui.svg',
        imgId: 'statistics',
        label: 'security-policies-nav-simulation',
        content: 'simulation'
      }
    ];
  }

  getTabs(type: string) {
    if (type === 'compromise-reports') {
      return [
        {
          id: 'compromise-reports-list',
          img: 'assets/icons/list.svg',
          imgId: 'list',
          label: 'compromise-reports-nav-report-list',
          content: 'compromise-reports'
        },
        {
          id: 'statistics',
          img: 'assets/icons/statistics.svg',
          imgId: 'statistics',
          label: 'compromise-reports-nav-statistics',
          content: 'statistics'
        }
      ];
    }
    if (type === 'attestations') {
      return [
        {
          id: 'attestations-list',
          img: 'assets/icons/probesFamilies/black&White.png',
          imgId: 'bw',
          label: 'attestations-nav-report-list',
          content: 'attestations'
        },
        /*{  
          id: 'browser-attestations',
          img: 'assets/icons/BrowserAttestations/logoWP.png',
          imgId: 'wp',
          label: 'browser-attestations-nav-statistics',
          content: 'browser-attestations'
        },*/
        {
          id: 'statistics',
          img: 'assets/icons/statistics.svg',
          imgId: 'statistics',
          label: 'attestations-nav-statistics',
          content: 'statistics'
        }
      ];
    }
    return [];
  }

  isAdmin(){
    return this.keycloak.hasRealmRole('bo-dip-wl-admin');
  }

  hasBothAttestationsRoles(){
    return this.keycloak.hasRealmRole('bo-dip-attestations-viewer') && this.keycloak.hasRealmRole('bo-dip-browser-attestations-viewer');
  }
}
